export enum PartecipantRoles {
    PrimaryClient = 'PrimaryClient',
    SecondaryClient = 'SecondaryClient',
    GuestClient = 'GuestClient',
    SuperClient = 'SuperClient',
    OnSiteOperator = 'OnSiteOperator'
}


export const OPERATOR_ROLES = [PartecipantRoles.PrimaryClient, PartecipantRoles.SuperClient];
export const GUEST_ROLES = [PartecipantRoles.GuestClient, PartecipantRoles.SuperClient];